/* eslint-env mocha */
export default {
  data () {
    return {
      plans: {
        annual: {
          g1: {
            cost: 4788,
            reviewInvites: 600,
            reviewCredits: 60,
            replyCredits: 60
          },
          g2: {
            cost: 8388,
            reviewInvites: 1200,
            reviewCredits: 120,
            replyCredits: 120
          },
          g3: {
            cost: 11988,
            reviewInvites: 1800,
            reviewCredits: 180,
            replyCredits: 180
          },
          g4: {
            cost: 19188,
            reviewInvites: 3000,
            reviewCredits: 240,
            replyCredits: 240
          },
          p1: {
            cost: 31188,
            reviewInvites: 6000,
            reviewCredits: 500,
            replyCredits: 500
          },
          p2: {
            cost: 53988,
            reviewInvites: 12000,
            reviewCredits: 750,
            replyCredits: 750
          },
          p3: {
            cost: 71988,
            reviewInvites: 18000,
            reviewCredits: 1000,
            replyCredits: 1000
          },
          p4: {
            cost: 95988,
            reviewInvites: 99999999,
            reviewCredits: 99999999,
            replyCredits: 99999999
          }
        },
        monthly: {
          free: {
            cost: 0,
            reviewInvites: 20,
            reviewCredits: 0,
            replyCredits: 3
          },
          g1: {
            cost: 399,
            reviewInvites: 50,
            reviewCredits: 5,
            replyCredits: 5
          },
          g2: {
            cost: 699,
            reviewInvites: 100,
            reviewCredits: 10,
            replyCredits: 10
          },
          g3: {
            cost: 999,
            reviewInvites: 150,
            reviewCredits: 15,
            replyCredits: 15
          },
          g4: {
            cost: 1599,
            reviewInvites: 250,
            reviewCredits: 20,
            replyCredits: 20
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/plans.js